import { RunnerDetailsSection, type SectionStatus } from "@/components/runners/details/RunnerDetailsSection";
import type { PlainMessage } from "@bufbuild/protobuf";
import { type Runner } from "gitpod-next-api/gitpod/v1/runner_pb";
import { type FC, useMemo } from "react";
import { CloudFormationStack } from "@/components/runners/details/CloudFormationStack";
import { LinuxRunnerSetup } from "@/components/runners/details/LinuxRunnerSetup";
import { RunnerProvider, RunnerKind } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";

export const RunnerProviderSetup: FC<{ runner: PlainMessage<Runner> | undefined; hasSignedUp: boolean }> = ({
    runner,
    hasSignedUp,
}) => {
    const setupComponent = useMemo(() => {
        if (!runner) {
            // Return empty div for skeleton loading state
            return <div className="h-[200px]" />;
        }

        switch (runner.provider) {
            case RunnerProvider.AWS_EC2:
                return <CloudFormationStack runner={runner} hasStack={hasSignedUp} />;
            case RunnerProvider.LINUX_HOST:
                return <LinuxRunnerSetup runner={runner} hasSignedUp={hasSignedUp} />;
            default:
                return (
                    <div className="p-4">
                        <p className="text-content-secondary">
                            No setup instructions available for this provider type.
                        </p>
                    </div>
                );
        }
    }, [runner, hasSignedUp]); // Only recreate when runner or hasSignedUp changes

    if (runner && runner.kind !== RunnerKind.REMOTE) {
        return null;
    }

    let status: SectionStatus = "loading";
    if (runner) {
        status = hasSignedUp ? "complete" : "required";
    }

    return <RunnerDetailsSection status={status}>{setupComponent}</RunnerDetailsSection>;
};
